import Field from '../Field';

const uszip = /(?:^\d{5}(?:-\d{4})?(?:\.(?:[\d\w]){0,5})?$)/;
const cazip = /^([a-zA-Z][0-9][a-zA-Z])\s?([0-9][a-zA-Z][0-9])$/;

class ZipCode extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (force || this.validIndex[index]) {
        if (val === undefined || val === null) {
          val = '';
        }

        val = String(val);

        // Add space for Canadian zip if necessary & caps
        if (cazip.test(val)) {
          const matches = val.match(cazip);
          val = `${matches[1]} ${matches[2]}`.toUpperCase();
        }

        this.setValue(val, index);
        this.setDisplayValue(val, index);
      }
    });

    return this;
  }

  validate() {
    this.sanitize(true);
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (!uszip.test(val) && !cazip.test(val)) {
        this.invalidate('Invalid zip code.', index);
      }
    });

    return this.isValid();
  }
}

export default ZipCode;
